import script from "./UserPermissionsDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserPermissionsDialog.vue?vue&type=script&lang=ts&setup=true"

import "./UserPermissionsDialog.vue?vue&type=style&index=0&id=a618dc64&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a618dc64"]])

export default __exports__